import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OpenXLogo } from "../../../assets/icons";
import bgImage from "../../../assets/webp/SignInBGImage.webp";
import { ButtonComponent } from "../../components/button";
import styles from "./style.module.css";
import { useInitializeResetPasswordMutation, useVerifyResetPasswordTokenMutation } from "../../../redux/services/authApi";

export const ForgotPasswordOtp: React.FC = () => {

  const [otp, setOtp] = useState<string[]>(Array(6).fill(""));
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const navigate = useNavigate();
    const [verifyResetPasswordToken] = useVerifyResetPasswordTokenMutation();
    const [initializeResetPassword] = useInitializeResetPasswordMutation();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    // keep only digits and take the last typed char
    const raw = e.target.value.replace(/\D/g, "");
    const char = raw.slice(-1); // last digit or ""

    setOtp((prev) => {
      const copy = [...prev];
      copy[index] = char ?? "";
      return copy;
    });

    if (char && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === "ArrowRight" && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    index: number
  ) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    if (!pasted) return;

    setOtp((prev) => {
      const copy = [...prev];
      let i = index;
      for (const d of pasted.slice(0, 6 - index)) {
        copy[i] = d;
        i++;
      }
      // focus next empty or last filled
      const nextIndex = Math.min(index + pasted.length, 5);
      setTimeout(() => inputRefs.current[nextIndex]?.focus(), 0);
      return copy;
    });
  };

  const instructiontext = "Enter the six digit code sent to your Email address";

    useEffect(() => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      setEmail(urlParams.get('email') as string);
      console.log('Received email for verification:', urlParams.get('email'));
    }, []);

  const verify = async () => {
    
    if(isLoading)
    {
      console.log("Is Processing");
      return;
    }

    setIsLoading(true);

    const code = otp.join('');
    console.log('OTP Entered:', code);
    console.log('Email Retrieved:', email);

    setErrorMessage(null);


    if (!code || code.length !== 6 || !/^\d+$/.test(code)) {
      // Checks for exactly 6 digits
      setErrorMessage('• Please enter the complete 6-digit OTP.');
      console.log(errorMessage);
      setIsLoading(false); // Stop loading if validation fails
      return; // Exit the function
    }

    if (!email) {
      setErrorMessage('• Email is missing. Please return to the registration page.');
      console.log(errorMessage);
    setIsLoading(false);

      return;
    }

    try {
      const payload = await verifyResetPasswordToken({ email, code }).unwrap();

      // this will come in later later
      // setTokenItem(TOKEN_KEY.AUTH_TOKEN, payload.access_token);
      // setTokenItem(TOKEN_KEY.REFRESH_TOKEN, payload.refresh_token);

      console.log("Success Here");
    const encodedEmail = encodeURIComponent(email);
      const verificationLink = `/forgotPassword-newPassword?email=${encodedEmail}`;
      navigate(verificationLink);

    }       catch (err: any) {
        console.error('API error:', err);

        // RTK Query wraps errors in a standard structure
        if (err?.data?.detail) {
          setErrorMessage(`• ${err.data.detail}`);
        console.log('API error:', err);

        } else if (err?.error) {
          setErrorMessage(`• ${err.error}`);
        console.log('API error:', err);

        } else {
          setErrorMessage('• Something went wrong. Please try again.');
        }
      } 
    finally
    {
    setIsLoading(false);
      
    }
  };



  const ResendOTP = async () => 
    {

      setErrorMessage("");

      if(isLoading)
      {
        console.log("Still Processing")
        setIsLoading(false);
        return;
      }

    //   if(!isValidEmail(email))
    //   {
    //     console.log("• Email must be a valid email address")
    //     setErrorMessage("• Email must be a valid email address")
    //     setIsLoading(false);
    //     return;
    //   }

      setIsLoading(true);

      try {
        const payload = await initializeResetPassword({ email }).unwrap();
        const encodedEmail = encodeURIComponent(email);
        const verificationLink = `/forgotPassword-otp?email=${encodedEmail}`;
        navigate(verificationLink);
      } 
      catch (err: any) {
        console.error('API error:', err);

        // RTK Query wraps errors in a standard structure
        if (err?.data?.detail) {
          setErrorMessage(`• ${err.data.detail}`);
        console.log('API error:', err);

        } else if (err?.error) {
          setErrorMessage(`• ${err.error}`);
        console.log('API error:', err);

        } else {
          setErrorMessage('• Something went wrong. Please try again.');
        }
      } 
      finally {
        setIsLoading(false);
      }

    }



  return (
    <div className={styles.container}>
      <img className={styles.bgImg} src={bgImage} alt="Gallery Background" />
      <div className={styles.entryContainer}>
        <OpenXLogo className={styles.icon} />
        <div className={styles.headerTxt}>Forgot Password?</div>
        <div className={styles.alignDiv}>
                    <div className={styles.instr}>{instructiontext}</div>

        <div className={styles.otpCont}>
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              pattern="\d*"
              autoComplete="one-time-code"
              maxLength={1}              
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={(e) => handlePaste(e, index)}
              className={styles.otpInput}
            />
          ))}
        </div>
        <div className={styles.errMsg}>{errorMessage}</div>

          <div className={styles.resendCont}>
          Didn’t get an email?
            <div className={styles.resend} onClick={ResendOTP}>Resend</div>
        </div>


        <ButtonComponent
          buttonName={isLoading ? "Verifying..." : "Verify"}
          style={{ 
            marginTop: 40,
            marginBottom: 36, 
            width: "100%", 
            height: "46px",
            border: 0,
            opacity: isLoading ? 0.5 : 1  
        }}
          handleclick={verify}
        />
        </div>
      </div>
    </div>
  );
};
